import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchJournals } from '../query-api'
import { Journal } from '../types/journal'

interface UseFetchJournalsProps {
  isDisabled?: boolean
}

interface UseFetchJournalsResponse {
  isLoading: boolean
  journals: Journal[]
}

export const useFetchJournals = ({ isDisabled }: UseFetchJournalsProps = {}): UseFetchJournalsResponse => {
  const { organization } = useUserOrganization()

  const { data, isLoading } = useQuery(
    [QueryKeys.Journals, organization?.id],
    () => fetchJournals(organization?.id as string),
    {
      enabled: !!organization?.id && !isDisabled,
      staleTime: defaultStaleTime,
    },
  )

  return {
    isLoading,
    journals: data?.journals ?? [],
  }
}
